"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var firebase = __importStar(require("firebase/app"));
var core_1 = require("@21st-night/core");
var slate_1 = require("slate");
var Button_1 = __importDefault(require("../../Button"));
var CardFormContainer_1 = __importDefault(require("../CardFormContainer"));
var EditCardFormContainer = function (_a) {
    var onSuccess = _a.onSuccess, onCancel = _a.onCancel;
    var deck = core_1.useDeck();
    var db = core_1.useFirebase().db;
    var uploads = core_1.useUploads().uploads;
    var originalCard = core_1.useCardForm().originalCard;
    // Typecast to Card because it's always
    // defined when updating.
    var card = originalCard;
    var _b = __read(react_1.useState(false), 2), loading = _b[0], setLoading = _b[1];
    var _c = __read(react_1.useState(false), 2), confirmDelete = _c[0], setConfirmDelete = _c[1];
    var handleSubmit = react_1.useCallback(function (values, note) { return __awaiter(void 0, void 0, void 0, function () {
        var editor, isInline_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, deck.updateCard(card, values)];
                case 1:
                    _a.sent();
                    setLoading(false);
                    if (values.note && note) {
                        if (note) {
                            editor = slate_1.createEditor();
                            isInline_1 = editor.isInline;
                            editor.isInline = function (node) { return node.type === 'card-link' || isInline_1(node); };
                            editor.children = note.content;
                            slate_1.Transforms.wrapNodes(editor, { type: 'card-link', cardId: card.id, children: [] }, {
                                split: true,
                                at: note.selection,
                            });
                            db.collection('notes')
                                .doc(values.note)
                                .update({
                                content: JSON.stringify(editor.children),
                                cards: firebase.firestore.FieldValue.arrayUnion(card.id),
                            });
                        }
                    }
                    onSuccess(__assign(__assign(__assign({}, card), values), { question: JSON.stringify(values.question), answer: JSON.stringify(values.answer), explanation: JSON.stringify(values.explanation), summary: JSON.stringify(values.summary) }));
                    return [2 /*return*/];
            }
        });
    }); }, [deck, card, onSuccess, db]);
    var handleDelete = react_1.useCallback(function () {
        deck.removeCard(card.id);
        if (onSuccess) {
            onSuccess();
        }
    }, [deck, card.id, onSuccess]);
    var showConfirmDelete = react_1.useCallback(function () {
        setConfirmDelete(true);
    }, []);
    var hideConfirmDelete = react_1.useCallback(function () {
        setConfirmDelete(false);
    }, []);
    return (react_1.default.createElement(CardFormContainer_1.default, { onSubmit: handleSubmit, secondaryAction: react_1.default.createElement(react_1.Fragment, null, confirmDelete ? (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(Button_1.default, { variant: "text", size: "large", onClick: hideConfirmDelete, disabled: loading }, "Cancel"),
            react_1.default.createElement(Button_1.default, { variant: "clear", color: "danger", size: "large", onClick: handleDelete, disabled: loading }, "Confirm Delete"))) : (react_1.default.createElement(Button_1.default, { variant: "clear", size: "large", color: "danger", onClick: showConfirmDelete, disabled: loading }, "Delete Card"))), actionButtons: [
            react_1.default.createElement(Button_1.default, { variant: "clear", size: "large", onClick: onCancel, disabled: loading }, "Cancel"),
            react_1.default.createElement(Button_1.default, { type: "submit", variant: "contained", color: "primary", size: "large", disabled: loading || uploads.length > 0 }, "Update"),
        ] }));
};
exports.default = EditCardFormContainer;
//# sourceMappingURL=EditCardFormContainer.js.map